// extracted by mini-css-extract-plugin
module.exports = {"item":"GridItem_item__p6SUA"};